// import * as apiAdministration from "@api/administration";
// import React, { useState, useCallback, useEffect } from "react";
// import styles from "./AdminAnnunciEUtenti.module.css";
// import { useSnackbars } from "@contexts/SnackbarsContext";

// const AdminAnnunciEUtenti = () => {
//   const { openSnackbar } = useSnackbars();

//   const [loading, setLoading] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [page, setPage] = useState(1);
//   const [filter, setFilter] = useState("");

//   const loadUsers = useCallback(() => {
//     setLoading(true);
//     apiAdministration
//       .GetUsers({ page, filter })
//       .then(setUsers)
//       .catch((e) => openSnackbar("❌ " + e.message))
//       .finally(() => setLoading(false));
//   }, [page, filter, openSnackbar]);

//   useEffect(() => {
//     loadUsers();
//   }, [loadUsers]);

//   return (
//     <>
//       <div className="row">
//         <div className="col">
//           <span className="page-title">Gestione utenti</span>
//         </div>
//       </div>
//       <br />

//       {/* Search filter */}
//       <div className="row mb-3">
//         <div className="col">
//           <input
//             type="text"
//             placeholder="Cerca..."
//             value={filter}
//             onChange={(e) => setFilter(e.target.value)}
//           />
//           <button disabled={loading} onClick={() => loadUsers()}>
//             Cerca
//           </button>
//         </div>
//       </div>

//       {/* Users table */}
//       <div className="row">
//         <div className="col">
//           <div className={styles.tableAnnunci}>
//             <table className="table">
//               <thead>
//                 <tr>
//                   <th>ID</th>
//                   <th>Nome</th>
//                   <th>Cognome</th>
//                   <th>Email</th>
//                   <th>Telefono</th>
//                   <th>Credits</th>
//                   <th>Admin</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {users.length === 0 && !loading && (
//                   <tr>
//                     <td colSpan="7">Nessun utente trovato</td>
//                   </tr>
//                 )}
//                 {users.map((u) => (
//                   <tr key={u.id}>
//                     <td>{u.id}</td>
//                     <td>{u.name}</td>
//                     <td>{u.lastName}</td>
//                     <td>{u.email}</td>
//                     <td>{u.cel || u.tel}</td>
//                     <td>{u.credits ?? 0}</td>
//                     <td>{u.isAdmin ? "✅" : ""}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* Pagination */}
//       <div className="row mt-3">
//         <div className="col">
//           <button
//             disabled={loading || page === 1}
//             onClick={() => setPage((p) => Math.max(1, p - 1))}
//           >
//             ← Prev
//           </button>
//           <span style={{ margin: "0 10px" }}>Pagina {page}</span>
//           <button
//             disabled={loading || users.length === 0}
//             onClick={() => setPage((p) => p + 1)}
//           >
//             Next →
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AdminAnnunciEUtenti;
import * as apiAdministration from "@api/administration";
import * as apiPublic from "@api/public";
import React, { useState, useCallback, useEffect, useMemo } from "react";
import styles from "./AdminAnnunciEUtenti.module.css";
import { useSnackbars } from "@contexts/SnackbarsContext";
import SelectCategory from "@templates/selectCategory";

const AdminAnnunciEUtenti = () => {
  const { openSnackbar } = useSnackbars();

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState("");

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [userDetailsLoading, setUserDetailsLoading] = useState(false);

  const [ads, setAds] = useState([]);
  const [adsLoading, setAdsLoading] = useState(false);

  const [publishingPackages, setPublishingPackages] = useState([]);
  const [publishingPackagesLoading, setPublishingPackagesLoading] = useState(false);

  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);

  const [packageCategoryId, setPackageCategoryId] = useState(null);
  const [packageAmount, setPackageAmount] = useState("1");
  const [packageExpirationDate, setPackageExpirationDate] = useState("");

  const loadUsers = useCallback(() => {
    setLoading(true);
    apiAdministration
      .GetUsers({ page, filter }) // già presente
      .then(setUsers)
      .catch((e) => openSnackbar("❌ " + e.message))
      .finally(() => setLoading(false));
  }, [page, filter, openSnackbar]);

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  const loadCategories = useCallback(() => {
    setCategoriesLoading(true);
    apiPublic
      .GetCategories()
      .then((data) => setCategories(data ?? []))
      .catch((e) => {
        setCategories([]);
        openSnackbar("❌ Categorie: " + e.message);
      })
      .finally(() => setCategoriesLoading(false));
  }, [openSnackbar]);

  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  // carica dettagli utente selezionato
  const loadUserDetails = useCallback(
    (userId) => {
      if (!userId) return;
      setUserDetailsLoading(true);
      apiPublic
        .GetUser({ userId: userId })
        .then((data) => {
          setUserDetails(data);
        })
        .catch((e) => openSnackbar("❌ Dettagli utente: " + e.message))
        .finally(() => setUserDetailsLoading(false));
    },
    [openSnackbar]
  );

  // carica annunci dell'utente selezionato
  const loadUserAds = useCallback(
    (userId) => {
      if (!userId) return;
      setAdsLoading(true);
      apiPublic
        .GetUserAdvertisements?.({userId})
        .then((res) => setAds(res ?? []))
        .catch((e) => openSnackbar("❌ Annunci: " + e.message))
        .finally(() => setAdsLoading(false));
    },
    [openSnackbar]
  );

  const loadPublishingPackages = useCallback(
    (userId) => {
      if (!userId) return;
      setPublishingPackagesLoading(true);
      apiAdministration
        .GetPublishingPackages({ userId: Number(userId) })
        .then((res) => setPublishingPackages(res ?? []))
        .catch((e) => {
          setPublishingPackages([]);
          openSnackbar("❌ Pacchetti: " + e.message);
        })
        .finally(() => setPublishingPackagesLoading(false));
    },
    [openSnackbar]
  );

  // quando cambia utente selezionato o pagina annunci
  useEffect(() => {
    if (!selectedUserId) {
      setPublishingPackages([]);
      return;
    }
    loadUserDetails(selectedUserId);
    loadUserAds(selectedUserId);
    loadPublishingPackages(selectedUserId);
  }, [selectedUserId, loadUserDetails, loadUserAds, loadPublishingPackages]);

  useEffect(() => {
    setPackageCategoryId(null);
    setPackageAmount("1");
    setPackageExpirationDate("");
  }, [selectedUserId]);

  const categoryNameById = useMemo(() => {
    const map = new Map();
    categories.forEach((category) => {
      map.set(String(category.id), category?.name || String(category.id));
    });
    return map;
  }, [categories]);

  // click riga
  const handleSelect = (u) => {
    setSelectedUserId(u.id);
  };

  // azioni
  const handleOpenProfile = () => {
    if (!selectedUserId) return;
    // adegua l’URL se hai un route diverso
    window.open(`/utente/${selectedUserId}`, "_blank", "noopener,noreferrer");
  };

  const handleAddCredits = async () => {
    if (!selectedUserId) return;
    const input = window.prompt("Aggiungi crediti: inserisci importo intero", "10");
    if (!input) return;
    const amount = Number(input);
    if (!Number.isFinite(amount) || amount <= 0) {
      openSnackbar("❌ Importo non valido");
      return;
    }
    try {
      await apiAdministration.AddCredits?.({ userId: selectedUserId, amount });
      openSnackbar("✅ Crediti aggiunti");
      // ricarica dettagli per aggiornare saldo
      loadUserDetails(selectedUserId);
    } catch (e) {
      openSnackbar("❌ " + e.message);
    }
  };

  const handlePackageCategoryChange = useCallback((newCategoryId) => {
    setPackageCategoryId(newCategoryId ?? null);
  }, [setPackageCategoryId]);

  const handleCreatePublishingPackage = useCallback(
    async (event) => {
      event.preventDefault();
      if (!selectedUserId) {
        openSnackbar("❌ Nessun utente selezionato");
        return;
      }

      if (packageCategoryId === null || packageCategoryId === undefined) {
        openSnackbar("❌ Seleziona una categoria");
        return;
      }

      const categoryIdNumber = Number(packageCategoryId);
      if (!Number.isFinite(categoryIdNumber)) {
        openSnackbar("❌ Categoria non valida");
        return;
      }

      const amount = Number.parseInt(packageAmount, 10);
      if (!Number.isFinite(amount) || amount <= 0) {
        openSnackbar("❌ Quantità non valida");
        return;
      }

      if (!packageExpirationDate) {
        openSnackbar("❌ Inserisci una data di scadenza");
        return;
      }

      const expirationDate = new Date(packageExpirationDate);
      if (Number.isNaN(expirationDate.getTime())) {
        openSnackbar("❌ Data di scadenza non valida");
        return;
      }

      try {
        await apiAdministration.CreatePublishingPackage({
          userId: Number(selectedUserId),
          categoryId: categoryIdNumber,
          amount,
          expirationDate: expirationDate.toISOString(),
        });
        openSnackbar("✅ Pacchetto creato");
        setPackageCategoryId(null);
        setPackageAmount("1");
        setPackageExpirationDate("");
        loadPublishingPackages(selectedUserId);
      } catch (e) {
        openSnackbar("❌ Pacchetto: " + e.message);
      }
    },
    [loadPublishingPackages, openSnackbar, packageAmount, packageCategoryId, packageExpirationDate, selectedUserId]
  );

  const handleDeletePublishingPackage = useCallback(
    async (packageId) => {
      if (!selectedUserId) {
        return;
      }

      const confirmed = window.confirm("Eliminare il pacchetto selezionato?");
      if (!confirmed) {
        return;
      }

      try {
        await apiAdministration.DeletePublishingPackage({ id: Number(packageId) });
        openSnackbar("✅ Pacchetto eliminato");
        loadPublishingPackages(selectedUserId);
      } catch (e) {
        openSnackbar("❌ Pacchetto: " + e.message);
      }
    },
    [loadPublishingPackages, openSnackbar, selectedUserId]
  );

  return (
    <>
      <div className="row">
        <div className="col">
          <span className="page-title">Gestione utenti</span>
        </div>
      </div>
      <br />

      {/* filtro */}
      <div className="row mb-3">
        <div className="col">
          <input
            type="text"
            placeholder="Cerca..."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <button disabled={loading} onClick={() => loadUsers()}>
            Cerca
          </button>
        </div>
      </div>

      {/* tabella utenti */}
      <div className="row">
        <div className="col">
          <div className={styles.tableAnnunci}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Cognome</th>
                  <th>Email</th>
                  <th>Telefono</th>
                  <th>Credits</th>
                  <th>Admin</th>
                </tr>
              </thead>
              <tbody>
                {users.length === 0 && !loading && (
                  <tr>
                    <td colSpan="7">Nessun utente trovato</td>
                  </tr>
                )}
                {users.map((u) => {
                  const selected = u.id === selectedUserId;
                  return (
                    <tr
                      key={u.id}
                      onClick={() => handleSelect(u)}
                      style={{
                        cursor: "pointer",
                        backgroundColor: selected ? "rgba(0,0,0,0.05)" : "transparent",
                      }}
                      title="Seleziona per vedere i dettagli"
                    >
                      <td>{u.id}</td>
                      <td>{u.name}</td>
                      <td>{u.lastName}</td>
                      <td>{u.email}</td>
                      <td>{u.cel || u.tel}</td>
                      <td>{u.credits ?? 0}</td>
                      <td>{u.isAdmin ? "✅" : ""}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* paginazione lista utenti */}
      <div className="row mt-3">
        <div className="col">
          <button
            disabled={loading || page === 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            ← Prev
          </button>
          <span style={{ margin: "0 10px" }}>Pagina {page}</span>
          <button
            disabled={loading || users.length === 0}
            onClick={() => setPage((p) => p + 1)}
          >
            Next →
          </button>
        </div>
      </div>

      {/* pannello dettagli + azioni */}
      {selectedUserId && (
        <>
          <hr />
          <div className="row">
            <div className="col">
              <h4>Dettagli utente</h4>
              {userDetailsLoading && <div>Caricamento…</div>}
              {!userDetailsLoading && userDetails && (
                <div className={styles.userDetailsBox}>
                  <div><strong>ID:</strong> {userDetails.id}</div>
                  <div><strong>Nome:</strong> {userDetails.name} {userDetails.lastName}</div>
                  <div><strong>Email:</strong> {userDetails.email}</div>
                  <div><strong>Telefono:</strong> {userDetails.cel || userDetails.tel}</div>
                  <div><strong>Credits:</strong> {userDetails.credits ?? 0}</div>
                  <div><strong>Admin:</strong> {userDetails.isAdmin ? "Sì" : "No"}</div>
                  {/* aggiungi altri campi se disponibili */}
                </div>
              )}

              <div className="mt-2" style={{ display: "flex", gap: 8 }}>
                <button onClick={handleOpenProfile}>Apri profilo</button>
                <button onClick={handleAddCredits}>Aggiungi crediti</button>
              </div>
            </div>
          </div>

          {/* pacchetti annunci */}
          
          <hr />
          <div className="row">
            <div className="col">
              <h4>Pacchetti annunci</h4>
              {publishingPackagesLoading && <div>Caricamento…</div>}
              {!publishingPackagesLoading && publishingPackages.length === 0 && (
                <div>Nessun pacchetto disponibile</div>
              )}
              {!publishingPackagesLoading && publishingPackages.length > 0 && (
                <div className={styles.tableAnnunci}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Categoria</th>
                        <th>Numero annunci</th>
                        <th>Scadenza</th>
                        <th>Stato</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {publishingPackages.map((pkg) => (
                        <tr key={pkg.id}>
                          <td>{pkg.id}</td>
                          <td>{categoryNameById.get(String(pkg.categoryId)) ?? pkg.categoryId}</td>
                          <td>{pkg.amount}</td>
                          <td>{pkg.expirationDate ? new Date(pkg.expirationDate).toLocaleDateString() : "-"}</td>
                          <td>{pkg.isExpired ? "Scaduto" : "Attivo"}</td>
                          <td>
                            <button
                              type="button"
                              onClick={() => handleDeletePublishingPackage(pkg.id)}
                              disabled={publishingPackagesLoading}
                            >
                              Elimina
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              <form className={styles.packageForm} onSubmit={handleCreatePublishingPackage}>
                <div className={styles.packageCategoryField}>
                  <SelectCategory
                    value={packageCategoryId}
                    setValue={handlePackageCategoryChange}
                    disabled={categoriesLoading || categories.length === 0}
                  />
                </div>

                <label>
                  Numero annunci
                  <input
                    type="number"
                    min="1"
                    step="1"
                    value={packageAmount}
                    onChange={(event) => setPackageAmount(event.target.value)}
                  />
                </label>

                <label>
                  Scadenza
                  <input
                    type="date"
                    value={packageExpirationDate}
                    onChange={(event) => setPackageExpirationDate(event.target.value)}
                  />
                </label>

                <button type="submit" disabled={publishingPackagesLoading}>
                  Crea pacchetto
                </button>
              </form>

              {categoriesLoading && <div>Caricamento categorie…</div>}
            </div>
          </div>

          {/* annunci utente */}
          <div className="row mt-4">
            <div className="col">
              <h4>Annunci dell’utente</h4>
              {adsLoading && <div>Caricamento…</div>}
              {!adsLoading && ads.length === 0 && <div>Nessun annuncio</div>}
              {!adsLoading && ads.length > 0 && (
                <div className={styles.tableAnnunci}>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Titolo</th>
                        {/* <th>Status</th> */}
                        {/* <th>Creato il</th> */}
                        {/* aggiungi colonne se servono */}
                      </tr>
                    </thead>
                    <tbody>
                      {ads.map((a) => (
                        <tr key={a.id}>
                          <td>{a.id}</td>
                          <td>{a.title}</td>
                          {/* <td>{a.status}</td>
                          <td>{a.createdAt ? new Date(a.createdAt).toLocaleDateString() : "-"}</td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AdminAnnunciEUtenti;
